import * as React from 'react'

import cn from 'classnames'

import classes from './FiftyFifty.module.scss'

interface FiftyFiftyProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode[]
  imageTextSmall?: boolean
  inverse?: boolean
  leftStyles?: unknown
  rightStyles?: unknown
  customProps?: boolean
}

const getInlineStyle = (value: unknown) =>
  value && typeof value === 'object' && !Array.isArray(value)
    ? (value as React.CSSProperties)
    : undefined

export const FiftyFifty = ({
  children,
  className,
  imageTextSmall,
  inverse,
  leftStyles,
  rightStyles,
  customProps,
  ...props
}: FiftyFiftyProps) => {
  const content = React.Children.toArray(children)

  return (
    <div
      className={cn(
        classes.root,
        imageTextSmall && classes.imageTextSmall,
        inverse && classes.inverse,
        customProps && classes.customProps,
        className
      )}
      {...props}
    >
      <div
        className={cn(
          classes.column,
          classes.leftColumn,
          imageTextSmall && classes.imageTextSmall,
          inverse && classes.inverse,
          customProps && classes.customProps
        )}
        style={getInlineStyle(leftStyles)}
      >
        {content[0]}
      </div>
      <div
        className={cn(
          classes.column,
          classes.rightColumn,
          imageTextSmall && classes.imageTextSmall,
          customProps && classes.customProps
        )}
        style={getInlineStyle(rightStyles)}
      >
        {content[1]}
      </div>
    </div>
  )
}

export default FiftyFifty
